/** @jsx jsx */
import { jsx } from 'theme-ui';
import PropTypes from 'prop-types';

export const BackgroundFrame = ({ backgroundImage, frameIndex, ...props }) => {
  const frameHeight = 530;
  const zLayer = frameIndex + 1;
  const xPosition = frameIndex * frameHeight * -1;
  return (
    <div
      sx={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: '1600px',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right',
        width: '100%',
        height: '100%',
        position: 'absolute',
        zIndex: zLayer,
        top: 0,
        transition: 'opacity 1000ms',
        opacity: 0,
      }}
      {...props}
    />
  );
};

export const Container = ({ testvar, ...props }) => {
  // const tvar = testvar + 10;
  return (
    <section
      sx={{
        width: '100%',
      }}
      {...props}
    />
  );
};

Container.propTypes = {
  testvar: PropTypes.number.isRequired,
};

BackgroundFrame.propTypes = {
  backgroundImage: PropTypes.string.isRequired,
  frameIndex: PropTypes.string.isRequired,
};

BackgroundFrame.defaultProps = {
};
